import { render, staticRenderFns } from "./auth-signup.vue?vue&type=template&id=72e7e988&"
import script from "./auth-signup.vue?vue&type=script&lang=js&"
export * from "./auth-signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports